import React from "react";
import moment from "moment";
// import DateFilterTable from "../Content/DateFilterTable";
import { ExportPo } from "../../../utils/ExportUtils";
import DateRangePicker from "../DateRangePicker";

const SearchAndFilter = ({
  searchTerm,
  setSearchTerm,
  searchPlaceholder = "ค้นหาเอกสาร...",
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  showDateFilter = true,
  onAddNew,
  addButtonText = "เพิ่มใหม่",
  showAddButton = true,
  additionalFilters = null,
  className = "p-3 rounded-3 my-2 shadow-lg bg-white",
  name,
  filteredItems,
  bulkMode,
  onToggleBulk,
}) => {
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    localStorage.setItem("searchTerm", value);
  };

  const rangeValue = React.useMemo(() => ({
    start: startDate || null,
    end: endDate || null,
  }), [startDate, endDate]);

  const onRangeChange = (r) => {
    if (typeof setStartDate === 'function' && typeof setEndDate === 'function') {
      const s = r?.start ? moment(r.start).format('YYYY-MM-DD') : '';
      const e = r?.end ? moment(r.end).format('YYYY-MM-DD') : '';
      setStartDate(s);
      setEndDate(e);
      localStorage.setItem('startDate', s);
      localStorage.setItem('endDate', e);
    }
  };

  return (
    <div className={className}>
      <div className="row align-items-center">
        {/* Search Input */}
        <div className="col-md-4">
          <div className="input-group">
            <input
              type="text"
              placeholder={searchPlaceholder}
              className="form-control"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <span className="input-group-text">
              <i className="fas fa-search"></i>
            </span>
          </div>
        </div>

        {/* Date Filter */}
        {showDateFilter && (
          <div className="col-md-4 d-flex">
            <DateRangePicker
              className="col-md-10 d-flex"
              value={rangeValue}
              onChange={onRangeChange}
            />
          </div>
        )}

        {/* Additional Filters */}
        {additionalFilters && (
          <div className={`col-md-${showDateFilter ? "2" : "7"}`}>
            {additionalFilters}
          </div>
        )}

        {(window.location.pathname === "/purchase-order" || showAddButton) && (
          <div
            className={`col-md-${showDateFilter ? "4" : additionalFilters ? "4" : "12"
              } d-flex justify-content-end align-items-center`}
          >
            {window.location.pathname === "/purchase-order" && typeof onToggleBulk === 'function' && (
              <button
                onClick={onToggleBulk}
                className="btn btn-lg text-white me-2"
                type="button"
                style={{ minWidth: "180px", borderRadius: "2rem", backgroundColor: bulkMode ? "#ff0000ff" : "#24af50ff" }}
              >
                {bulkMode ? "ยกเลิกโหมดอนุมัติ" : "อนุมัติหลายรายการ"}
              </button>
            )}
            {showAddButton && (
              <button
                onClick={onAddNew}
                className="btn btn-warning text-white"
                style={{ backgroundColor: "#F17F25", borderRadius: "2rem" }}
              >
                {addButtonText} <i className="fa fa-plus"></i>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchAndFilter;
